module.exports = __webpack_public_path__ + "static/media/MacArthur_DARKBG.ec9fd599.png";